export const MODAL_TITLE = "Calculator";
export const SAVE_BTN_TEXT = "Save";
export const CANCEL_BTN_TEXT = "Calculate";

export const SUBTITLE = "Calculator for how much can one make";

export const TOGGLE_LABEL = "Show total income on the dashboard";

export const SLIDER_LABELS = {
  CLIENTS: "Number of desired clients per week",
  CLIENTS_HINT:
    "Most active graduates set goals for 10 to 20 clients per week. We recommend 15",
  SESSION_LENGTH: "Session Length in hours",
  SESSION_LENGTH_HINT: "Standard Session Length is 2hrs",
};

export const INPUT_LABELS = {
  RATE: "Rate",
  RATE_HINT: "Most active graduates charge $90 to $150 per hour",
  RATE_PLACEHOLDER: "RATE",
  DATE: "Date",
  DATE_HINT: "When you want to be seeing this many clients",
};

export const RESULT_LABELS = {
  WEEKLY: "Weekly amount:",
  WEEKLY_SUFFIX: "/week",
  ANNUAL: "Annual amount:",
  ANNUAL_SUFFIX: "/year",
};

export const DISCLAIMER_TEXT =
  "IIH does not promise or guarantee any income. This calculator is intended solely for goal-setting purposes.";

export const ERROR_MESSAGES = {
  START_DATE: "Please select a start date",
  RATE: "Please enter a rate",
  DESIRED_CLIENTS: "Please enter desired clients",
  SAVE_FAILED: "Failed to save the data",
};

export const SLIDER_CONFIG = {
  CLIENTS_MAX: 30,
  SESSION_LENGTH_MAX: 3,
};

export const RATE_INPUT_CONFIG = {
  MIN: 1,
  MAX: 100000,
};
